import type {DataRouterBlobPayload} from '@github-ui/code-view-types'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {SerializableQueryDeps} from '@github-ui/react-core/future/data-router-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {fileTreeQuery} from '../queries/file-tree-query'

export const codeViewBlobRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewBlobRoute', {
  path: '/:owner/:repo/blob/:branch/*',
  queries: [
    mainQuery<DataRouterBlobPayload>({
      queryDeps: ({pathname, searchParams}) => {
        if (isFeatureEnabled('react_data_router_serializable_query_deps')) {
          return {pathname, searchParams: Object.fromEntries(searchParams)}
        }
        // TODO(react_data_router_serializable_query_deps): remove cast and legacy branch when flag is at 100%.
        return {pathname, searchParams} as unknown as SerializableQueryDeps & {pathname: string}
      },
      encodeFetchPath: true,
    }),
    fileTreeQuery,
  ],
})
